import React from 'react';
import ObservabilityPanel from '../components/ObservabilityPanel';

export default function Observability() {
  return (
    <div className="min-h-screen bg-[#050505]">
      {/* The panel manages its own sticky header + scrollable list */}
      <div className="max-w-6xl mx-auto h-[calc(100vh-3.5rem)]">
        <ObservabilityPanel />
      </div>
    </div>
  );
}
